import styled from 'styled-components';
import { media, Button, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const MultipleVsIndustryTableWrapper = styled('div')`
  width: 100%;

  background: ${({ theme }) => theme.color.charcoal};
  border-radius: ${({ theme }) => theme.x1spacePx}px;

  ${media.smDown`
    border-radius: 0px;
    width: 100vw;
    margin: 0px ${({ theme }) => -theme.x2spacePx}px;
  `}
`;

export const ShowMoreButton = styled(Button)`
  background: none;
  &&&:hover {
    background: ${({ theme }) => theme.color.brand03RGBA(0.05)};
  }
  color: ${({ theme }) => theme.color.brand01};
`;

export const ButtonWrapper = styled('div')`
  width: 100%;
  padding: ${({ theme }) => theme.x1spacePx}px;
  padding-top: 4px;
`;

interface FillerMessageProps {
  companiesMissing: number;
}

export const FillerMessage = styled('div')<FillerMessageProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${({ theme }) => theme.typography.tiny};
  color: ${({ theme }) => theme.color.mediumGray};
  height: ${({ companiesMissing, theme }) =>
    52 + companiesMissing * theme.x4spacePx}px;

  ${media.smDown`
    height: ${({ companiesMissing, theme }) =>
      52 + companiesMissing * (theme.x6spacePx + 4)}px;
  `}
`;

export const ActionSheetTableWrapper = styled('div')`
  color: ${({ theme }) => theme.color.white};
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  ${media.mdUp`
    padding: 0px ${({ theme }) => theme.x4spacePx}px;
  `};
`;

export const StyledGrid = styled(Grid)`
  position: relative;
`;

export const Hidden = styled('div')`
  display: none;
`;
